<template>
    <Dialog :style="{width: '35vw'}" :closable="false" :showHeader="false" :visible="!!message" :modal="true">
        <span style="white-space: pre-wrap">{{ message }}</span>
        <template #footer>
            <Button label="OK" icon="pi pi-check" @click="close" autofocus />
        </template>
    </Dialog>
</template>

<script>
export default {
    props: {
        message: String
    },
    model: {
        event: ['closed']
    },
    methods: {
        close() {
            this.$emit('closed');
        }
    }
}
</script>